import {CHATCOFFEE_LANGUAGE_ORDER} from './languageManifest';

export const CHATCOFFEE_LOCALES = CHATCOFFEE_LANGUAGE_ORDER;

export type ChatCoffeeLocaleId = (typeof CHATCOFFEE_LOCALES)[number];
export const CHATCOFFEE_DEFAULT_LOCALE: ChatCoffeeLocaleId = `en-US`;
